
// 01_Summaries 
import Simple_A                from '../01_Summaries/Simple_A/index.vue'

import Status_A                from '../01_Summaries/Status_A/index.vue'
import Status_B                from '../01_Summaries/Status_B/index.vue'
import Status_Group            from '../01_Summaries/Status_Group/index.vue'
import Status_Punch            from '../01_Summaries/Status_Punch/index.vue'

import Progress_A              from '../01_Summaries/Progress_A/index.vue'
import Progress_B              from '../01_Summaries/Progress_B/index.vue'
import Progress_C              from '../01_Summaries/Progress_C/index.vue'

import Cube_A                  from '../01_Summaries/Cube_A/index.vue'
import Cube_C                  from '../01_Summaries/Cube_C/index.vue'
import Cube_SC                 from '../01_Summaries/Cube_SC/index.vue'

import Donut_Status            from '../01_Summaries/Donut_Status/index.vue'
import WeekStatus              from '../01_Summaries/WeekStatus/index.vue'


// 02 DataTables 
import TBL_Integration         from '../02_DataTables/Integration/index.vue'
import TBL_Scrollbar           from '../02_DataTables/Scrollbar/index.vue'
import TBL_Modal_Normal        from '../02_DataTables/Modal_Normal/index.vue'
import TBL_NDE_Normal          from '../02_DataTables/NDE_Normal/index.vue'
import TBL_NDE_Trion           from '../02_DataTables/NDE_Trion/index.vue'
import TBL_Progress            from '../02_DataTables/Progress/index.vue'
import TBL_Punch               from '../02_DataTables/Punch/index.vue'

// 03 Primavera
import P6_TABLE_EL             from '../03_Primavera/Table_EL/index.vue'
import P6_TABLE_MD             from '../03_Primavera/Table_MD/index.vue'
import P6_TUBE_EL              from '../03_Primavera/Tube_EL/index.vue'
import P6_TUBE_MD              from '../03_Primavera/Tube_MD/index.vue'
import P6_GAUGE_MD             from '../03_Primavera/Gauge_MD/index.vue'

// 04 Histogram 
import HIS_SCURVE_MINI         from '../04_Histogram/Axes/Scurve_Mini/index.vue'
import HIS_PUNCH_MINI          from '../04_Histogram/Axes/Punch_Mini/index.vue'
import HIS_STACK               from '../04_Histogram/Axes/Stack/index.vue'
import HIS_PUNCH               from '../04_Histogram/Axes/Punch/index.vue'
import HIS_PUNCH_STACK         from '../04_Histogram/Axes/Punch_Stack/index.vue'
import HIS_SCURVE              from '../04_Histogram/Axes/Scurve/index.vue'

import BAR_VER_MULTI           from '../04_Histogram/Bar/Ver_Multi/index.vue'
import BAR_HOZ_MULTI           from '../04_Histogram/Bar/Hoz_Multi/index.vue'
import BAR_TRENDS              from '../04_Histogram/Bar/Trends/index.vue'
import BAR_STACKS              from '../04_Histogram/Bar/Stacks/index.vue'

// 04 Charts 
import CHT_RADAR               from '../05_Charts/Radar/index.vue'
import CHT_RADAR2              from '../05_Charts/Radar2/index.vue'
import CHT_PIE                 from '../05_Charts/Pie/index.vue'
import CHT_DONUT               from '../05_Charts/Donut/index.vue'
import CHT_TUBE                from '../05_Charts/Tube/index.vue'
import CHT_TUBE_MULTI          from '../05_Charts/Tube_Multi/index.vue'
import CHT_GAUGE               from '../05_Charts/Gauge/index.vue'
import CHT_GAUGE_FC            from '../05_Charts/Gauge_FC/index.vue'
import CHT_GAUGE_QTY           from '../05_Charts/Gauge_Qty/index.vue'
import CHT_GAUGE_QTY2          from '../05_Charts/Gauge_Qty2/index.vue'
import CHT_SKYLINE_MINI        from '../05_Charts/Skyline_Mini/index.vue'
import CHT_RADIAL              from '../05_Charts/Radial/index.vue'

// 06 Reports
import RPT_SCURVE_MS           from '../06_Reports/Planning/SCurve_MS/index.vue'
import RPT_PROGRESS_EL         from '../06_Reports/Planning/Progress_EL/index.vue'
import RPT_SCURVE_BLOCK        from '../06_Reports/Construction/SCurve_Block/index.vue'
import RPT_ERECTION_STATUS     from '../06_Reports/Construction/Erection_Status/index.vue'
import RPT_SYSTEM_STATUS       from '../06_Reports/SystemCompletion/System_Status/index.vue'
import RPT_SUBSYSTEM_LIST      from '../06_Reports/SystemCompletion/SubSystem_List/index.vue'
import RPT_SYSTEM_LIST         from '../06_Reports/SystemCompletion/System_List/index.vue'
import RPT_CON_Status          from '../06_Reports/Planning/Report_Status/index.vue'

// Viewer
import Filter_Viewer           from '../00_System/Filter_Viewer/index.vue'
import Text_Editor             from '../00_System/TextEditor/index.vue'
import Sundries2               from '../00_System/Sundries2/index.vue'
import Components              from '../00_System/Components/index.vue'
import Index_BlockStage        from '../00_System/Index_BlockStage/index.vue'
import DB_Diagram              from '../00_System/Diagram/index.vue'
import Database                from '../00_System/Database/index.vue'
import Workorder               from '../00_System/WorkOrder/index.vue'

export default {

  // 01_Summaries
  
  Simple_A,
  Status_A,
  Status_B,
  Status_Group,
  Status_Punch,
  Progress_A,
  Progress_B,
  Progress_C,
  Cube_A,
  Cube_C,
  Cube_SC,
  WeekStatus,
  Donut_Status,

  // 02 DataTables
  TBL_Integration,
  TBL_Scrollbar,
  TBL_Modal_Normal,
  TBL_NDE_Normal,
  TBL_NDE_Trion,
  TBL_Progress,
  TBL_Punch,

  // 03 Primavera
  P6_TABLE_EL,
  P6_TABLE_MD,
  P6_TUBE_EL,
  P6_TUBE_MD,
  P6_GAUGE_MD,
  
  // 04 Charts
  HIS_SCURVE_MINI,
  HIS_PUNCH_MINI,
  HIS_STACK,
  HIS_PUNCH,
  HIS_PUNCH_STACK,
  HIS_SCURVE,
  BAR_VER_MULTI,
  BAR_HOZ_MULTI,
  BAR_TRENDS,
  BAR_STACKS,

  // 05 Charts 
  CHT_RADAR,
  CHT_RADAR2,
  CHT_PIE,
  CHT_DONUT,
  CHT_TUBE,
  CHT_TUBE_MULTI,
  CHT_GAUGE,
  CHT_GAUGE_FC,
  CHT_GAUGE_QTY,
  CHT_GAUGE_QTY2,
  CHT_SKYLINE_MINI,
  CHT_RADIAL,

  // 06 Report
  RPT_SCURVE_MS,
  RPT_PROGRESS_EL,
  RPT_SCURVE_BLOCK,
  RPT_ERECTION_STATUS,
  RPT_SYSTEM_STATUS,
  RPT_SUBSYSTEM_LIST,
  RPT_SYSTEM_LIST,
  RPT_CON_Status,

  // System
  Filter_Viewer,
  Text_Editor,
  Sundries2,
  Components,
  Index_BlockStage,
  DB_Diagram,
  Database,
  Workorder,
}
